module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_5010.2297af4b.png";